import { DoctorRoleGroupId, NurseRoleGroupId, SocialWorkerRoleGroupId, SpiritualRoleGroupId, AideRoleGroupId, VolunteerRoleGroupId, OccupationalTherapyRoleGroupId, SpeechTherapyRoleGroupId, PhysicalTherapyRoleGroupId, ClinicalVolunteerRoleGroupId } from '../roleData'; // frequencies

/**
 * Retired (OP-31747): no longer offered by the period selectors. Kept so rows
 * saved before the retirement still display and schedule as once every two
 * weeks.
 */

export const BiWeekly = 'Bi-Weekly';
/** Retired (OP-31747), see BiWeekly; legacy rows mean once every two months. */

export const BiMonthly = 'Bi-Monthly';
export const Refused = 'Refused';
export const ZeroFreq = '0';
export const AsNeeded = 'As Needed';
export const Daily = 'Daily';
export const Assess = 'Assess';
export const Discontinued = 'Discontinued';
export const Weekly = 'Weekly';
export const Monthly = 'Monthly';
export const TwentyFourHours = '24 Hours';
export const OneXAssess = '1 X Assess'; // frequency abbreviations

export const BIWK = 'BI-WK';
export const BIMO = 'BI-MO';
export const DIS = 'DIS';
export const WK = 'WK';
export const AS = 'to assess';
export const M = 'M';
export const MO = 'MO';
export const T = 'T';
export const TU = 'TU';
export const W = 'W';
export const WE = 'WE';
export const THU = 'THU';
export const TH = 'TH';
export const F = 'F';
export const FR = 'FR';
export const SAT = 'SAT';
export const SA = 'SA';
export const SUN = 'SUN';
export const SU = 'SU';
export const FREQ = 'FREQ=';
export const BYDAY = 'BYDAY=';
export const daysOfTheWeek = [SUN, M, T, W, THU, F, SAT];
export const rRuleDaysOfTheWeek = {
  [M]: MO,
  [T]: TU,
  [W]: WE,
  [THU]: TH,
  [F]: FR,
  [SAT]: SA,
  [SUN]: SU
};
export const ICSFrequencyMap = {
  [Daily]: Daily.toUpperCase(),
  [Weekly]: Weekly.toUpperCase(),
  [BiWeekly]: `${Weekly.toUpperCase()};INTERVAL=2`,
  [Monthly]: Monthly.toUpperCase(),
  [BiMonthly]: `${Monthly.toUpperCase()};INTERVAL=2`
};
/**
 * Periods that can no longer be chosen for new care plan frequency rows.
 * Existing rows keep rendering; the selectors in Care Plan - Visit Frequency
 * and Orders and Progress Notes leave them out.
 */

export const retiredPeriodNames = [BiWeekly, BiMonthly]; // Orders and Progress Notes

export const NotScheduled = 'Not Scheduled';
export const NotAssigned = 'Not Assigned'; // care plan status

export const Incomplete = 'incomplete'; // additional default care plan frequency fields

export const fields = {
  discipline: '',
  workerName: NotScheduled,
  frequencyText: '',
  effectiveDate: '',
  status: Incomplete,
  isCurrentPlan: true,
  nonCurrentRows: []
}; // props to add to role group info from authproxy

export const rgProps = {};
rgProps[DoctorRoleGroupId.toString()] = {
  id: DoctorRoleGroupId,
  order: 1,
  defaultRoleGroup: false
};
rgProps[NurseRoleGroupId.toString()] = {
  id: NurseRoleGroupId,
  order: 2,
  defaultRoleGroup: true
};
rgProps[SocialWorkerRoleGroupId.toString()] = {
  id: SocialWorkerRoleGroupId,
  order: 3,
  defaultRoleGroup: true
};
rgProps[SpiritualRoleGroupId.toString()] = {
  id: SpiritualRoleGroupId,
  order: 4,
  defaultRoleGroup: true
};
rgProps[AideRoleGroupId.toString()] = {
  id: AideRoleGroupId,
  order: 5,
  defaultRoleGroup: true
};
rgProps[VolunteerRoleGroupId.toString()] = {
  id: VolunteerRoleGroupId,
  order: 6,
  defaultRoleGroup: true
};
rgProps[OccupationalTherapyRoleGroupId.toString()] = {
  id: OccupationalTherapyRoleGroupId,
  name: 'Oc. Therapy',
  order: 7,
  defaultRoleGroup: false
};
rgProps[SpeechTherapyRoleGroupId.toString()] = {
  id: SpeechTherapyRoleGroupId,
  name: 'Sp. Therapy',
  order: 7,
  defaultRoleGroup: false
};
rgProps[PhysicalTherapyRoleGroupId.toString()] = {
  id: PhysicalTherapyRoleGroupId,
  name: 'Ph. Therapy',
  order: 7,
  defaultRoleGroup: false
};
rgProps[ClinicalVolunteerRoleGroupId.toString()] = {
  id: ClinicalVolunteerRoleGroupId,
  order: 7,
  defaultRoleGroup: false
};